export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.table_label_expand') || '展开',
    slots: {
      content: 'expandContent'
    },
    showHeaderOverflow: true,
    visible: false
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 140,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'userTripRequestNo',
    align: 'center',
    width: 150,
    title: that.$l('table_label_userTripRequestNo') || '出差申请单号',
    showHeaderOverflow: 'title'
  },
  {
    field: 'userTripRequestStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.Status') || '出差申请单状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: true
  },
  {
    field: 'salesPersonName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    title: that.$l('table_label_applicant') || '申请人',
    showHeaderOverflow: 'title'
  },
  {
    field: 'requestDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    title: that.$l('table_label_requestDate') || '申请日期',
    showHeaderOverflow: 'title'
  },
  {
    field: 'tripStartDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    title: that.$l('table_label_tripStartDate') || '出差起始日',
    showHeaderOverflow: 'title'
  },
  {
    field: 'tripEndDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    title: that.$l('table_label_tripEndDate') || '出差终止日',
    showHeaderOverflow: 'title'
  },
  {
    field: 'tripDays',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_tripDays') || '出差天数',
    showHeaderOverflow: 'title'
  },
  {
    field: 'departureCityName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_departure_city_name') || '出差起始地',
    showHeaderOverflow: 'title'
  },
  {
    field: 'destinationCityName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    title: that.$l('table_label_destination_city_name') || '出差目的地',
    showHeaderOverflow: 'title'
  },
  {
    field: 'tripStartTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_tripStartTime') || '出发时间',
    showHeaderOverflow: 'title'
  },
  {
    field: 'tripEndTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_tripEndTime') || '返回时间',
    showHeaderOverflow: 'title'
  },
  {
    field: 'cashAdvances',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    title: that.$l('table_label_cashAdvances') || '暂支旅费',
    showHeaderOverflow: 'title'
  },
  {
    field: 'tripRemark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: that.$l('table_label_tripRemark') || '备注',
    showHeaderOverflow: 'title',
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true
  }
]
